import { keyframes, styled } from '@mui/system'
import { TTheme } from '@/core/theme'

const skeletonShimmer = keyframes`
    0% {
        background-position: -200px 0;
    }
    100% {
        background-position: calc(200px + 100%) 0;
    }
`

type StyledSkeletonBarProps = {
    theme?: TTheme
    width: number
    height: number
    borderRadius: number
}

export const StyledSkeletonBar = styled('span')<StyledSkeletonBarProps>`
    display: inline-block;
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};
    border-radius: ${({ borderRadius }) => `${borderRadius}px`};
    background-color: ${({ theme }) => theme.colors.greys[100]};
    background-image: ${({ theme }) =>
        `linear-gradient(
            90deg,
            ${theme.colors.greys[100]} 0%,
            ${theme.colors.greys[200]} 50%,
            ${theme.colors.greys[100]} 100%
        )`};
    background-size: 200px 100%;
    background-repeat: no-repeat;
    animation: ${skeletonShimmer} 1.4s ease-in-out infinite;
`
